import { ComponentPropsWithoutRef, ReactNode } from 'react';
import styled from 'styled-components';
import { width } from '../styles/theme';

const ButtonContainer = styled.div`
  position: fixed;
  bottom: 1.5em;
  left: 0;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  width: ${width.container}px;
  margin: 0 auto;
  padding-bottom: 15px;
  text-align: center;

  @media (max-width: ${width.phone}px) {
    text-align: center;
    width: 100%;
  }

  @media (min-width: ${width.tablet}px) {
    text-align: right;
    padding-right: 24px;
    padding-left: 24px;
  }

  @media (min-width: ${width.desktop}px) {
    text-align: left;
    padding-left: 24px;
    padding-right: 24px;
  }

  @media (max-width: ${width.container}px) {
    width: 100%;
  }
`;

type FloatingButtonProps = ComponentPropsWithoutRef<'div'> & {
  children: ReactNode;
};

const FloatingButton = ({ children, ...rest }: FloatingButtonProps) => (
  <ButtonContainer {...rest}>
    <ButtonWrapper>{children}</ButtonWrapper>
  </ButtonContainer>
);

export default FloatingButton;
